import { useCallback } from "react"
import cc from "classcat"

interface Option {
  label: string
  value: string
  disabled?: boolean
}

interface ToggleGroupProps {
  options: Option[]
  value: string | number
  small?: boolean
  vertical?: boolean
  className?: string
  onChange: (value: string | number) => void
}

interface ToggleGroupButtonProps {
  isActive: boolean
  label: string
  value: string | number
  small?: boolean
  disabled?: boolean
  onClick: (value: string | number) => void
}

const ToggleGroupButton = ({
  isActive,
  label,
  value,
  disabled,
  onClick,
  small,
}: ToggleGroupButtonProps) => {
  const handleClick = useCallback(() => onClick(value), [value, onClick])
  const classes = cc({
    "toggle-group__btn": true,
    "toggle-group__btn--active": isActive,
    "toggle-group__btn--disabled": disabled,
    "toggle-group__btn--small": small,
  })

  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      className={classes}
      aria-pressed={isActive}
    >
      {label}
    </button>
  )
}

export const ToggleGroup = ({
  options,
  value,
  onChange,
  small,
  vertical,
  className,
}: ToggleGroupProps) => (
  <div
    role="group"
    className={cc([
      "toggle-group",
      className,
      { "toggle-group--small": small },
      { "toggle-group--vertical": vertical },
    ])}
  >
    {options.map((option) => (
      <ToggleGroupButton
        key={option.value}
        isActive={option.value === value}
        value={option.value}
        label={option.label}
        disabled={option.disabled}
        onClick={onChange}
        small={small}
      />
    ))}
  </div>
)
